<template>
  <div v-if="token">
    <v-card class="px-5 mb-10">
      <v-row>
        <v-col cols="12" md="11" class="my-auto">
          <h3 class="primary--text">
            PETA JABATAN - {{ nama_unor.toUpperCase() }}
          </h3>
        </v-col>

        <MAdd />
        <MEdit />

        <v-col cols="12" md="1" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                @click="add()"
              >
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Tambah</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card>

    <v-card outlined>
      <v-card-title>
        Tampilan Hierarki
        <v-spacer />

        <v-btn
          text
          color="primary"
          @click="
            expandAll = !expandAll;
            expandVersion++;
          "
        >
          {{ expandAll ? "Tutup semua" : "Buka semua" }}
        </v-btn>
      </v-card-title>

      <v-divider />

      <div class="tree-viewport">
        <tree-view
          :items="data"
          :options="treeOptions"
          :expand-all="expandAll"
          :expand-version="expandVersion"
          @select="pilih_jabatan"
        />
      </div>

      <v-divider class="mt-10" />

      <v-card-text v-if="selectedNode">
        <strong>{{ selectedNode.nama }}</strong>
        <div class="text-caption">ID: {{ selectedNode.id }}</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import cookie from "@/helper/cookie.js";

import TreeView from "@/components/lib/TreeView.vue";
import MAdd from "@/components/anjab/petajabatan/add";
import MEdit from "@/components/anjab/petajabatan/edit";

import SData from "@/store/anjab/petajabatan";

export default {
  components: {
    TreeView,
    MAdd,
    MEdit,
  },

  data: () => ({
    session: "",
    token: "",
    loading: false,

    id_unor: "",
    nama_unor: "",

    data: [],
    selectedNode: null,
    expandAll: false,
    expandVersion: 0,

    treeOptions: {
      id: "id",
      label: "namaJabatan",
      children: "bawahan",
      subtitle: "",
      description: "alamat",
      icon: "",
      defaultExpandedDepth: 1,
    },
  }),

  computed: {
    refresh: {
      get() {
        return SData.state.refresh;
      },
    },

    alert_text: {
      get() {
        return SData.state.alertM;
      },
    },

    alert_b: {
      get() {
        return SData.state.alertB;
      },
    },

    alert_g: {
      get() {
        return SData.state.alertG;
      },
    },
  },

  watch: {
    refresh() {
      if (this.alert_b) {
        this.$swal({
          title: "Sukses!",
          text: this.alert_text,
          icon: "success",
        });
      } else if (this.alert_g) {
        this.$swal({
          title: "Gagal!",
          text: this.alert_text,
          icon: "error",
        });
      }

      this.get_data();
    },
  },

  async mounted() {
    this.session = await JSON.parse(cookie.dec(cookie.get("myCookie")));
    this.token = await cookie.get("token");
    this.id_unor = localStorage.getItem("id_unor");
    this.nama_unor = localStorage.getItem("nama_unor");

    this.get_data();
  },

  methods: {
    pilih_jabatan(node) {
      this.$router.push("/anjab/petajabatan/detail/" + node.id).catch(() => {});
    },

    get_data() {
      this.loading = true;

      const url = `${process.env.VUE_APP_API}/anjab/unor/${this.$route.params.id}`;

      this.axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.loading = false;
          SData.commit("refresh", false);
          this.data = res.data.mapData;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },

    add() {
      SData.commit("open_add", {
        value: true,
        item: this.id_unor,
      });
    },
  },
};
</script>
